import React, { FC } from "react"
import InlineCode from "./inlineCode"
import CSharp from "./csharp"

type FunctionProps = {
  name: string
  description: string
  methods: (string | JSX.Element)[]
  brokenRule?: string
}

export const ValidatorFunction: FC<FunctionProps> = ({
  name,
  description,
  methods,
  brokenRule,
  children,
}) => {
  return (
    <div className="mb-4" id={name}>
      <h2 className="font-semibold">{name}</h2>
      <p>{description}</p>
      <h5 className="font-semibold text-gray-800 text-sm my-4">Methods</h5>
      {methods.map((method) => (
        <>
          <InlineCode className="text-sm font-semibold text-blue-600 bg-blue-100">
            {method}
          </InlineCode>
          <br />
        </>
      ))}
      <h5 className="font-semibold text-gray-800 text-sm my-4">Broken Rule</h5>
      <p className="font-semibold font-mono text-sm text-red-600 inline px-1">
        {brokenRule}
      </p>
      <h5 className="font-semibold text-gray-800 text-sm mt-4">
        Example Usage
      </h5>
      {children}
    </div>
  )
}

type CodeExampleProps = {
  code: string
  label?: string | JSX.Element
}

export const CodeExample: FC<CodeExampleProps> = ({ label, code }) => (
  <>
    {label && <p className="text-gray-700 mb-0 pb-0 mt-4">{label}</p>}
    <CSharp code={code} />
  </>
)
